const mrpScheduledPurchaseHeader = [
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material',
        show: true
      },
      // {
      //   name: 'Mundo',
      //   id: 'produto-mundo',
      //   show: true
      // },
      {
        name: 'Categoria Compacta',
        id: 'produto-categoria-compacta',
        show: true
      },
      {
        name: 'Categoria',
        id: 'produto-categoria',
        show: true
      },
      {
        name: 'Sub Categoria',
        id: 'produto-sub-categoria',
        show: true
      },
      {
        name: 'Curva',
        id: 'produto-curva-abc',
        show: true
      },
      // {
      //   name: 'Curva ABC Empresa',
      //   id: 'produto-curva-abc-empresa',
      //   show: true
      // },
      {
        name: 'Status',
        id: 'produto-status',
        show: true
      },
      // {
      //   name: 'Gerente Produto Id',
      //   id: 'gerente-produto-id',
      //   show: true
      // },
      {
        name: 'Gerente Produto',
        id: 'gerente-produto-desc',
        show: true
      },
      {
        name: 'Lead Time',
        id: 'produto-lead-time',
        show: true
      },
      {
        name: 'Intervalo de Compra',
        id: 'produto-intervalo-compra',
        show: true
      },
      {
        name: 'Grupo de Separação',
        id: 'produto-grupo-separacao',
        show: true
      },
      {
        name: 'Lote Múltiplo',
        id: 'produto-lote',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Recomendação',
    columns: [
      {
        name: 'Pedidos',
        id: 'recomendacao-pedidos',
        show: true,
        isNumeric: true
      },
      {
        name: 'Quantidade',
        id: 'recomendacao-quantidade',
        show: true,
        isNumeric: true
      },
      {
        name: 'Peso',
        id: 'recomendacao-peso',
        show: false,
        isNumeric: true
      },
      {
        name: 'Volume',
        id: 'recomendacao-volume',
        show: true,
        isNumeric: true
      },
      {
        name: 'Custo (R$)',
        id: 'recomendacao-custo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Cobertura Média',
        id: 'recomendacao-cobertura-media',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Compra',
    columns: [
      {
        name: 'Peso',
        id: 'compra-peso',
        show: false,
        isNumeric: true
      },
      {
        name: 'Pedidos',
        id: 'compra-pedidos',
        show: true,
        isNumeric: true
      },
      {
        name: 'Quantidade',
        id: 'compra-quantidade',
        show: true,
        isNumeric: true
      },
      {
        name: 'Volume',
        id: 'compra-volume',
        show: true,
        isNumeric: true
      },

      {
        name: 'Custo (R$)',
        id: 'compra-custo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Cobertura Média',
        id: 'compra-cobertura-média',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'MAX',
        id: 'estoque-max',
        show: true,
        isNumeric: true
      },
      {
        name: 'Reservado',
        id: 'estoque-reservado',
        show: true,
        isNumeric: true
      },
      {
        name: 'Disponível',
        id: 'estoque-disponivel',
        show: true,
        isNumeric: true
      },
      {
        name: 'Trânsito Compra',
        id: 'estoque-transito',
        show: true,
        isNumeric: true
      },
      {
        name: 'Outros',
        id: 'estoque-outros',
        show: true,
        isNumeric: true
      },
      {
        name: 'Venda Média Diária',
        id: 'estoque-venda-diaria',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'VMM',
    columns: [
      {
        name: 'Primeira Entrada',
        id: 'vmm-primeira-entrada',
        show: false
      },
      {
        name: 'Janela Efetiva',
        id: 'vmm-janela-efetiva',
        show: false,
        isNumeric: true
      }
    ]
  }
]

export default mrpScheduledPurchaseHeader
